/**
 * Routes of the session feature, mounted inside the protected shell by
 * `src/App.tsx`. `/` itself is not listed here: it is wired directly by
 * `App.tsx` to `src/pages/HomePage.tsx`, which renders {@link StartPage}.
 */
import './session.css';

import { BuildingPage } from './pages/BuildingPage';
import { ClosePage } from './pages/ClosePage';
import { GuidancePage } from './pages/GuidancePage';
import { JoinSessionPage } from './pages/JoinSessionPage';
import { OpenSessionPage } from './pages/OpenSessionPage';
import { SummaryPage } from './pages/SummaryPage';

import type { RouteObject } from 'react-router-dom';

export const sessionRoutes: RouteObject[] = [
  { path: '/sessions/new', element: <OpenSessionPage /> },
  { path: '/sessions/join', element: <JoinSessionPage /> },
  { path: '/sessions/:id', element: <GuidancePage /> },
  { path: '/sessions/:id/building', element: <BuildingPage /> },
  { path: '/sessions/:id/close', element: <ClosePage /> },
  { path: '/sessions/:id/summary', element: <SummaryPage /> },
];
